import { PaymentService } from '@b2b/common/services';
import { ThemesHelperService } from '@b2b/common/services/themesHelper';
import { TODO } from '@b2b/types/core';
import { SecureCheckoutData } from '@b2b/types/payment';
import angular, { IFilterService, ISCEService, IScope } from 'angular';

interface SecureCheckoutItem extends SecureCheckoutData {
  amountFormatted: string;
  statusFormatted: string;
  updatedOnFormatted: string;
}

class CartSecureCheckoutController {
  static $inject = [
    '$scope',
    '$filter',
    '$sce',
    '$uibModal',
    'ThemesHelperService',
    'PaymentService',
    'PaymentProcessorService',
    'HelpersService',
    'CalendarService',
  ];

  vm = {
    showSecurePayment: false,
    hasVerification: false,
    loading: false,
    showRecomendations: false,
    secureCheckoutPreview: [] as TODO[],
    secureCheckoutList: [] as TODO[],
    secureCheckoutData: {},
    verificationError: '',
  };

  modal = {};

  statusType = {
    SUCCESS: 'Success',
    FAILED_STEPUP: 'Stepup Prompt from Bank',
    REJECTED: 'Failed',
  };

  textVars = {
    success: '',
    failed: '',
    rejected: '',
    none: '',
  };

  constructor(
    private $scope: IScope,
    private $filter: IFilterService,
    private $sce: ISCEService,
    private $uibModal: any,
    private ThemesHelperService: ThemesHelperService,
    private PaymentService: PaymentService,
    private PaymentProcessorService: TODO,
    private HelpersService: TODO,
    private CalendarService: TODO,
  ) {}

  $onInit() {
    this.initVM();
  }

  initVM() {
    this.vm.showSecurePayment = this.ThemesHelperService.getFeatureFlag('enable3DS');
    this.$scope.$on('Payment::SetSecureCheckoutData', () => {
      this.getFraudShieldVerification();
    });

    this.setTextVars();
  }

  setTextVars() {
    this.textVars.success = this.$sce.trustAsHtml(
      this.ThemesHelperService.getTextVariable(
        '3DS-success',
        `
      <p>
        Ask the guest: "Can you verify the last time you bought something?" <br />
        Use this to help verify this card is theirs and is not stolen.
      </p>
    `,
      ),
    );
    this.textVars.failed = this.$sce.trustAsHtml(
      this.ThemesHelperService.getTextVariable(
        '3DS-failed-stepup',
        `<p>Ask the guest: "Did you get an email, text, or phone call from your bank to verify?" For their security, have them try again online and respond to the prompt from their bank.</p>`,
      ),
    );
    this.textVars.rejected = this.$sce.trustAsHtml(
      this.ThemesHelperService.getTextVariable(
        '3DS-rejected',
        `
      <p>Tell the guest: "it looks like your bank declined your payment. Try contacting your bank to sort this out or try another card"</p>
      <p>If they request that you try processing, complete checkout. If you get a decline again, you can see the reason why.</p>
    `,
      ),
    );
    this.textVars.none = this.$sce.trustAsHtml(
      this.ThemesHelperService.getTextVariable(
        '3DS-none',
        `<p>Depends on what the guest called for help with. If possible, have them try agaun online. If they do and still have trouble, verify again and make sure you see that attempt. Otherwise, this might be someone trying to get us to process a stolen credit card.</p>`,
      ),
    );
  }

  getSecureCheckoutData() {
    this.vm.loading = true;
    this.vm.hasVerification = false;
    this.vm.verificationError = '';
    this.$scope.$emit('Payment::GetSecureCheckoutData');
  }

  getFraudShieldVerification() {
    this.PaymentService.getFraudShieldVerification()
      .then(() => {
        this.vm.secureCheckoutData = this.PaymentService.secureCheckoutData;

        this.vm.secureCheckoutList = this.PaymentService.secureCheckoutData?.list
          ? this.PaymentService.secureCheckoutData.list.map((item) => {
              return {
                ...item,
                amountFormatted: this.$filter('currency')(item.amount),
                statusFormatted: this.statusType[item.status],
                updatedOnFormatted: this.$filter('date')(
                  this.CalendarService.parseDate(item.updatedOn),
                  this.HelpersService.dateFormats.standardDateTime,
                ),
              };
            })
          : [];

        this.vm.secureCheckoutPreview = this.vm.secureCheckoutList.slice(0, 3);

        this.vm.loading = false;
        this.vm.hasVerification = true;
      })
      .catch((error) => {
        this.vm.loading = false;
        this.vm.hasVerification = false;
        this.vm.verificationError = error.data.error;
      });
  }

  isStatus(status: string) {
    const firstItem: SecureCheckoutItem = this.vm.secureCheckoutPreview[0];
    return firstItem.status === status;
  }

  viewAllRecomendations() {
    this.vm.showRecomendations = !this.vm.showRecomendations;
  }

  viewAllPaymentAttempts() {
    const allPaymentAttemps = this.vm.secureCheckoutList
      .map((item: SecureCheckoutItem) => {
        return `<li>
        <strong>
          ${item.statusFormatted}</strong> on 
          ${item.updatedOnFormatted} for 
          ${item.amountFormatted}
      </li>`;
      })
      .join('');

    this.modal = this.$uibModal.open({
      size: 'md',
      controller: 'ConfirmCustomModalController',
      templateUrl: 'common/views/modals/confirm/confirm.tpl.html',
      resolve: {
        modalTitle: function () {
          return 'Are you sure?';
        },
        okText: function () {
          return 'Done';
        },
        cancelText: function () {
          return 'Close';
        },
        modalMessage: function () {
          return '<ul>' + allPaymentAttemps + '</ul>';
        },
        hideOkText: function () {
          return true;
        },
      },
    });
  }
}

export const CartSecureCheckoutComponentModule = angular
  .module('acme.view.application.cart.components.cart-secure-checkout', [
    'ui.bootstrap',
    'acme.common.service.themesHelper',
    'acme.common.service.paymentProcessor',
    'acme.common.service.helpers',
    'acme.common.service.calendar',
    'acme.view.application.modals.confirmCustom.controllers',
  ])
  .component('acmeCartSecureCheckout', {
    templateUrl: 'views/application/views/cart/components/cart-secure-checkout/cart-secure-checkout.component.tpl.html',
    controller: CartSecureCheckoutController,
    controllerAs: '$ctrl',
    bindings: {},
  }).name;
